import { fork } from 'redux-saga/effects';

import bumpActivitySaga from './bumpActivity';
import connectToChannelSaga from './connectToChannel';
import conversationChangedSaga from './conversationChanged';
import disconnectSaga from './disconnect';
import fetchMessagesSaga from './fetchMessages';
import loadNextHistoryPageSaga from './loadNextHistoryPage';
import locationChangeSaga from './locationChange';
import newChannelActivitySaga from './newChannelActivity';
import reloadHistorySaga from './reloadHistory';
import sendMessageSaga from './sendMessage';
import setActiveChannelSaga from './setActiveChannel';
import removeChannelActivitySaga from './removeChannelActivity';
import updateChannelInboxTaskSaga from './update-channel-inbox-task-id-saga';
import socialChatSelectionSaga from './social-chat-selection-saga';
import socialChatInitSelectionSaga from './social-сhat-init-selection-saga';

export default function* root() {
  yield fork(bumpActivitySaga);
  yield fork(connectToChannelSaga);
  yield fork(conversationChangedSaga);
  yield fork(disconnectSaga);
  yield fork(fetchMessagesSaga);
  yield fork(loadNextHistoryPageSaga);
  yield fork(locationChangeSaga);
  yield fork(newChannelActivitySaga);
  yield fork(reloadHistorySaga);
  yield fork(sendMessageSaga);
  yield fork(setActiveChannelSaga);
  yield fork(removeChannelActivitySaga);
  yield fork(updateChannelInboxTaskSaga);
  yield fork(socialChatSelectionSaga);
  yield fork(socialChatInitSelectionSaga);
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/index.js